import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RelatedProductsElementModule } from 'src/business/grid/related-products/related-products.module';
import { UspBulkModule } from 'src/business/grid/usp-bulk/usp-bulk.module';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { VarModule } from 'src/core-lib/var/var.module';
import { GoogleMapsModule } from 'src/externals/google-maps/google-maps.module';
import { BreadcrumbsModule } from 'src/layout/breadcrumbs/breadcrumbs.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { BasketAddonLineStaticComponent } from './components/basket-addon-line-static/basket-addon-line-static.component';
import { BasketAddonLineComponent } from './components/basket-addon-line/basket-addon-line.component';
import { BasketAddressStaticComponent } from './components/basket-address-static/basket-address-static.component';
import { BasketLineStaticComponent } from './components/basket-line-static/basket-line-static.component';
import { BasketLineComponent } from './components/basket-line/basket-line.component';
import { BasketQuantityComponent } from './components/basket-quantity/basket-quantity.component';
import { BasketStaticComponent } from './components/basket-static/basket-static.component';
import { BasketSummaryComponent } from './components/basket-summary/basket-summary.component';
import { BasketComponent } from './components/basket/basket.component';
import { CheckoutAddressComponent } from './components/checkout-address/checkout-address.component';
import { CheckoutContactComponent } from './components/checkout-contact/checkout-contact.component';
import { CheckoutHoursOfOperationComponent } from './components/checkout-hours-of-operation/checkout-hours-of-operation.component';
import { CheckoutPaymentCardsComponent } from './components/checkout-payment-cards/checkout-payment-cards.component';
import { CheckoutPaymentComponent } from './components/checkout-payment/checkout-payment.component';
import { CheckoutShippingAddressComponent } from './components/checkout-shipping-address/checkout-shipping-address.component';
import { CheckoutShippingDroppointComponent } from './components/checkout-shipping-droppoint/checkout-shipping-droppoint.component';
import { CheckoutShippingComponent } from './components/checkout-shipping/checkout-shipping.component';
import { InvoiceAddonLineComponent } from './components/invoice-addon-line/invoice-addon-line.component';
import { InvoiceLineComponent } from './components/invoice-line/invoice-line.component';
import { AddonsPipe } from './pipes/addons.pipe';
import { ControlsPipe } from './pipes/controls.pipe';
import { GetExtrasPipe } from './pipes/get-extras.pipe';
import { MarkersPipe } from './pipes/markers.pipe';
import { ParentsPipe } from './pipes/parents.pipe';
import { SumTotalPricePipe } from './pipes/sum-total-price.pipe';


@NgModule({
    declarations: [
        AddonsPipe,
        BasketAddonLineComponent,
        BasketAddonLineStaticComponent,
        BasketAddressStaticComponent,
        BasketComponent,
        BasketLineComponent,
        BasketLineStaticComponent,
        BasketQuantityComponent,
        BasketStaticComponent,
        BasketSummaryComponent,
        CheckoutAddressComponent,
        CheckoutContactComponent,
        CheckoutHoursOfOperationComponent,
        CheckoutPaymentCardsComponent,
        CheckoutPaymentComponent,
        CheckoutShippingAddressComponent,
        CheckoutShippingComponent,
        CheckoutShippingDroppointComponent,
        ControlsPipe,
        GetExtrasPipe,
        InvoiceAddonLineComponent,
        InvoiceLineComponent,
        MarkersPipe,
        ParentsPipe,
        SumTotalPricePipe,
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
        MediaModule,
        NavigationModule,
        PipeModule,
        BreadcrumbsModule,
        GoogleMapsModule,
        GridModule,
        UspBulkModule,
        RelatedProductsElementModule,
        VarModule,
    ],
    exports: [
        AddonsPipe,
        BasketAddonLineComponent,
        BasketAddonLineStaticComponent,
        BasketAddressStaticComponent,
        BasketComponent,
        BasketLineComponent,
        BasketLineStaticComponent,
        BasketQuantityComponent,
        BasketStaticComponent,
        BasketSummaryComponent,
        BreadcrumbsModule,
        CheckoutAddressComponent,
        CheckoutContactComponent,
        CheckoutHoursOfOperationComponent,
        CheckoutPaymentCardsComponent,
        CheckoutPaymentComponent,
        CheckoutShippingAddressComponent,
        CheckoutShippingComponent,
        CheckoutShippingDroppointComponent,
        CommonModule,
        ControlsPipe,
        GetExtrasPipe,
        GoogleMapsModule,
        GridModule,
        InvoiceAddonLineComponent,
        InvoiceLineComponent,
        MarkersPipe,
        MediaModule,
        NavigationModule,
        ParentsPipe,
        PipeModule,
        ReactiveFormsModule,
        RelatedProductsElementModule,
        SumTotalPricePipe,
        TranslateModule,
        UspBulkModule,
        VarModule,
    ]
})
export class CheckoutPageModule {

}
